import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { getScorecardBaselineTable, getScorecardDetails } from "../../../actions/Scorecard";
import Scorecard from "../components/Scorecard";
import { getMasterServiceProvider } from "../../../actions/Master";
import { resetStates } from "../../../actions/Common";
import { excelDownload, getCompareNPIDetails } from "../../../actions/CompareNPI";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import { QuarterRange } from "../../../models/Scorecard";

const mapStateToProps = ({
  scorecardDetailsState,
  masterServiceProviderState,
  loggedInUserState,
  excelDownloadState,
  compareNPIDetailsState,
  scorecardBaselineTableState
}: ApplicationState) => ({
  scorecardData: scorecardDetailsState.response,
  scorecardError: scorecardDetailsState.error,
  scorecardErrorResponse: scorecardDetailsState,
  masterServiceProviderList: masterServiceProviderState.response,
  masterServiceProviderLoading: masterServiceProviderState.loading,
  loggedInUser: loggedInUserState.response,
  excelDownloadState: excelDownloadState.response,
  excelDownloadError: excelDownloadState.error,
  compareNPIData: compareNPIDetailsState.error,
  scorecardBaselineTableState: scorecardBaselineTableState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getMasterServiceProvider: () => {
      dispatch(getMasterServiceProvider());
    },
    getScorecardDetails: (providerNpi: string, quarterRange: QuarterRange , performancePeriod?:string) => {
      dispatch(getScorecardDetails(providerNpi, quarterRange, performancePeriod));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    getCompareNPIDetails: (userId: string) => {
      dispatch(getCompareNPIDetails(userId));
    },
    excelDownload: (npi: string, quarterRange: QuarterRange) => {
      dispatch(excelDownload(npi, quarterRange));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    getScorecardBaselineTable: (providerState: string, quarterRange: QuarterRange, pcmNpi: string) => {
      dispatch(getScorecardBaselineTable(providerState, quarterRange, pcmNpi));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Scorecard);
